document.addEventListener("DOMContentLoaded", () => {
    let isProcessing = false;

    function showSkeleton() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        
        const firstLineItem = cartDrawer.querySelector('line-item');
        if (!firstLineItem || cartDrawer.querySelector('.gift-skeleton')) return;
        
        const skeleton = document.createElement('div');
        skeleton.className = 'gift-skeleton';
        skeleton.innerHTML = `
            <div class="gift-skeleton__wrapper">
                <div class="gift-skeleton__image"></div>
                <div class="gift-skeleton__content">
                    <div class="gift-skeleton__line gift-skeleton__line--title"></div>
                    <div class="gift-skeleton__line gift-skeleton__line--subtitle"></div>
                </div>
            </div>
        `;
        
        firstLineItem.insertAdjacentElement('afterend', skeleton);
    }

    function hideSkeleton() {
        const skeleton = document.querySelector('.gift-skeleton');
        if (skeleton) skeleton.remove();
    }

    function fadeOutGiftItem() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        
        const giftLineItem = Array.from(cartDrawer.querySelectorAll('line-item')).find(item => {
            return item.classList.contains('line-item--gift');
        });
        
        if (giftLineItem) {
            giftLineItem.style.transition = 'opacity 0.3s ease';
            giftLineItem.style.opacity = '0.3';
        }
    }

    async function fetchCart() {
        const response = await fetch('/cart.js');
        return await response.json();
    }

    async function addFreeGift(variantId) {
        showSkeleton();
        
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                items: [{ 
                    id: variantId, 
                    quantity: 1,
                    properties: { '_gift': 'true' }
                }] 
            })
        });
        
        // Forcer le refresh du drawer pour réactiver le bouton
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        await new Promise(resolve => setTimeout(resolve, 300));
        hideSkeleton();
    }

    async function removeFreeGift(key) {
        fadeOutGiftItem();
        
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                id: key, 
                quantity: 0 
            })
        });
        
        // Forcer le refresh du drawer pour réactiver le bouton
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        await new Promise(resolve => setTimeout(resolve, 300));
    }

    async function getVariantIdFromProductHandle(handle) {
        const response = await fetch(`/products/${handle}.js`);
        const data = await response.json();
        const freeVariant = data.variants.find(v => v.price === 0);
        
        // Vérifier si le variant existe ET est disponible
        if (!freeVariant || !freeVariant.available) {
            return null;
        }
        
        return freeVariant.id;
    }

    async function handleGifts() {
        console.log("1")
        if (isProcessing) return;
        isProcessing = true;

        console.log("2")
        try {
            const cart = await fetchCart();
            const giftBlocks = document.querySelectorAll('[data-gift-product]');
            
            let subtotal = 0;
            cart.items.forEach((item) => {
                const isGift = item.properties && item.properties._gift === 'true';
                if (!isGift) subtotal += item.final_line_price;
            });
            subtotal = subtotal / 100;

            console.log("3")

            for (const block of giftBlocks) {
                const handle = block.dataset.giftProduct;
                const threshold = parseFloat(block.dataset.giftThreshold);

                console.log("4")

                if (!handle || isNaN(threshold)) continue;

                const variantId = await getVariantIdFromProductHandle(handle);
                if (!variantId) continue;

                const giftItem = cart.items.find(
                    item => item.variant_id === variantId && 
                           item.properties && 
                           item.properties._gift === 'true'
                );

                const isInCart = !!giftItem;
                const shouldBeInCart = subtotal >= threshold;

                if (shouldBeInCart && !isInCart) {
                    await addFreeGift(variantId);
                } else if (!shouldBeInCart && isInCart) {
                    await removeFreeGift(giftItem.key);
                }
            }
        } catch (error) {
            console.error('Error:', error);
            hideSkeleton();
        } finally {
            isProcessing = false;
        }
    }

    // Écouter les changements
    document.addEventListener('cart:change', () => {
        setTimeout(handleGifts, 100);
    });

    document.addEventListener('cart:refresh', () => {
        setTimeout(handleGifts, 100);
    });

    // Init
    setTimeout(handleGifts, 200);
});